import { ConfigComun } from "@/interfaces/Comun";
import { CiCircleInfo } from "react-icons/ci";
import FlotaVehicular from "../FlotaVehicular";
import { useFleetData } from "../../hooks/useFleetData";
import { useDriverData } from "../../hooks/useDriverData";
import { useEffect, useMemo } from "react";
import {
  transformDriverData,
  transformFleetData,
} from "../../data/data-transform";
import { useAppDispatch } from "@/stores/hooks";
import { setFleetData } from "@/stores/features/vehicleQuestionsSlice";
import { setDriverData } from "@/stores/features/driverQuestionSlice";

interface Props extends Partial<ConfigComun> {
  companyId: number;
  auditId: number;
  isOver?: boolean; //Para cuando se usa el componente por fuera osea solo para hacer el conteo del pesv
}
export default function QuantityForm({
  companyId,
  auditId,
  isExternal,
}: Props) {
  const dispatch = useAppDispatch();
  const { fleetByCompany, isLoadingFleetByCompany } = useFleetData(
    companyId,
    auditId || 0
  );  

  const { driverByCompanyid, isLoadingDriverByCompany } = useDriverData(
    companyId,
    auditId || 0
  );

  const fleetData = useMemo(() => {
    return fleetByCompany ? transformFleetData(fleetByCompany) : [];
  }, [fleetByCompany]);

  const driverCountData = useMemo(() => {
    return driverByCompanyid ? transformDriverData(driverByCompanyid) : [];
  }, [driverByCompanyid]);

  // 🔥 Actualizamos Redux SOLO cuando los datos realmente están listos
  useEffect(() => {
    if (!isLoadingFleetByCompany && fleetData.length > 0) {
      dispatch(setFleetData(fleetData));
    }

    if (!isLoadingDriverByCompany && driverCountData.length > 0) {
      dispatch(setDriverData(driverCountData));
    }
  }, [
    fleetData,
    driverCountData,
    isLoadingFleetByCompany,
    isLoadingDriverByCompany,
  ]);
  return (
    <div className="flex flex-col flex-1 w-full md:w-2/4">
      {isExternal && (
        <div className="flex items-center mb-2">
          <div className="flex flex-col items-center gap-4">
            <div className="flex flex-col">
              <span className="flex items-center gap-2">
                <CiCircleInfo />
                Flota Vehicular
              </span>
              <small>
                Incluye el número de vehículos automotores y no automotores
                puestos al servicio de la organización para el cumplimiento de
                sus funciones en los procesos estratégicos, misionales y de
                apoyo, ya sean vehículos propios, arrendados, en leasing,
                renting, entre otros, o que hagan parte de cualquier modelo de
                vinculación, contratación, intermediación o administración que
                realice la organización con el propietario, tenedor o conductor
                del vehículo, también incluye los vehiculos utilizados por los
                contratistas y trabajadores de la organización.
              </small>
            </div>
            <div className="flex flex-col">
              <span className="flex items-center gap-2">
                <CiCircleInfo />
                Conductores contratados
              </span>
              <small>
                corresponde al número de personas que utilizan un vehículo
                automotor y no automotor puesto al servicio de la organización
                para el cumplimiento de sus funciones, independientemente del
                modelo de contratación o administración (vinculación o
                intermediación) que utilice la organización.
              </small>
            </div>
          </div>
        </div>
      )}
      <FlotaVehicular companyId={companyId} auditId={auditId} />
    </div>
  );
}
